import React, { useState, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { forgotPassword, onErrorStopLoad } from "../../redux/slices/auth";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "react-toastify";
import { useAuthSelector } from "../../redux/selector/auth";
import * as Images from "../../utilities/images";

const ForgotPassword = () => {
  document.title = "Forgot Password";
  const toastId = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const authData = useAuthSelector();
  const { loading } = authData;
  const [email, setEmail] = useState("");

  // show only one toast at one time
  const showToast = (msg) => {
    if (!toast.isActive(toastId.current)) {
      toastId.current = toast.error(msg);
    }
  };

  // Form submit handler
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!email) {
      showToast("Please enter your email");
      return;
    } else if (
      email &&
      !/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z0-9_\-]+\.)+[a-zA-Z_]{2,}))$/.test(
        email
      )
    ) {
      showToast("Please enter valid email address");
      return;
    }
    let params = {
      email: email.trim(),
    };
    dispatch(
      forgotPassword({
        ...params,
        cb(ress) {
          if (ress.status === 200) {
            navigate("/enter-otp", {
              state: {
                email: email,
              },
            });
          }
        },
      })
    );
  };

  // stop loader on page load
  useEffect(() => {
    dispatch(onErrorStopLoad());
  }, [dispatch]);

  return (
    <>
      <div className="auth-bg-all">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 hey-admin-inner">
              <div className="hey-admin-inner">
                <h1 className="hey-title m-0">Hey👋</h1>
              </div>
              {/* <p className="admin-text-welcome">Welcome</p> */}
              <p className="admin-text">Admin</p>
            </div>
            <div className="col-lg-6">
              <div className="auth-outer-fields">
                <div className="text-center">
                  <img
                    className="mt-5"
                    alt="company-logo"
                    src={Images.brandLogo}
                  />
                </div>
                <div className="form-outer">
                  <div className="auth-heading-form">
                    <h1>Forgot password</h1>
                    <p>
                      Enter the email address that associated with your account
                      for Verify.
                    </p>
                  </div>
                  <form
                    onSubmit={(e) => {
                      handleSubmit(e);
                    }}
                  >
                    <div className="input-container text-filed-outer">
                      <input
                        type="text"
                        className="input-fileds"
                        placeholder="Email"
                        value={email}
                        onChange={(e) => {
                          setEmail(e.target.value);
                        }}
                      />
                      <img
                        className="input-images"
                        src={Images.Message}
                        alt="lock"
                      />
                    </div>
                    <div className="my-3 text-end">
                      <Link to="/" className="forgot-heading">
                        Login
                      </Link>
                    </div>
                    <div>
                      <button
                        disabled={loading}
                        className="auth-submit-button"
                        type="submit"
                      >
                        Continue &nbsp;&nbsp;
                        {loading && (
                          <span className="spinner-border spinner-border-sm"></span>
                        )}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ForgotPassword;
